import {
    GET_PURCHASEORDER_REQUEST, GET_PURCHASEORDER_SUCCESS, GET_PURCHASEORDER_FAIL,
    CREATE_PURCHASEORDER_REQUEST, CREATE_PURCHASEORDER_SUCCESS, CREATE_PURCHASEORDER_FAIL,
    UPDATE_PURCHASEORDER_REQUEST, UPDATE_PURCHASEORDER_SUCCESS, UPDATE_PURCHASEORDER_FAIL,
    DELETE_PURCHASEORDER_REQUEST, DELETE_PURCHASEORDER_SUCCESS, DELETE_PURCHASEORDER_FAIL,
    GET_VENDORPURCHASEORDER_REQUEST, GET_VENDORPURCHASEORDER_SUCCESS, GET_VENDORPURCHASEORDER_FAIL,
    GENERATE_PDF_REQUEST, GENERATE_PDF_SUCCESS, GENERATE_PDF_FAIL, GET_PURCHASEORDER_PAGINATION, GET_SELECTEDPO_FAIL, GET_SELECTEDPO_SUCCESS, GET_SELECTEDPO_REQUEST, ADD_SELECTED_INVOICE, REMOVE_SELECTED_INVOICE, CLEAR_SELECTED_PO, REMOVE_SELECTED_PO
} from "../types/purchaseOrderTypes";

function generatePdfReducer(state = { generatePdf: {} ,allCheckData: [], allSoIds: []  }, action) {
    switch (action.type) {
        case GENERATE_PDF_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GENERATE_PDF_SUCCESS:
            return {
                ...state,
                generatePdf: action.payload,
                isLoading: false
            }
        case GENERATE_PDF_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        case ADD_SELECTED_INVOICE:
            const data = state.allCheckData.filter(({ poId }) =>
                poId == action.payload.poId
            )
            if (data.length > 0) {
                const data = state.allCheckData.filter(({ poId }) => poId != action.payload.poId)
                const idsData = state.allSoIds.filter((poId) => poId != action.payload.poId)

                return {
                    ...state,
                    allCheckData: data,
                    allSoIds: idsData
                }
            } else {
                return {
                    ...state,
                    allCheckData: [...state.allCheckData, action.payload],
                    allSoIds: [...state.allSoIds, action.payload.poId]
                }
            }
    
        case REMOVE_SELECTED_INVOICE:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        case CLEAR_SELECTED_PO:
            return {
                ...state,
                allCheckData: [],
                allSoIds: []
            }
        default:
            return state;
    }
}


function deletePurchaseOrderReducer(state = { deletePurchaseOrder: {} }, action) {
    switch (action.type) {
        case DELETE_PURCHASEORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_PURCHASEORDER_SUCCESS:
            return {
                ...state,
                deletePurchaseOrder: action.payload,
                isLoading: false
            }
        case DELETE_PURCHASEORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updatePurchaseOrderReducer(state = { updatePurchaseOrder: {} }, action) {
    switch (action.type) {
        case UPDATE_PURCHASEORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_PURCHASEORDER_SUCCESS:
            return {
                ...state,
                updatePurchaseOrder: action.payload,
                isLoading: false
            }
        case UPDATE_PURCHASEORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function createPurchaseOrderReducer(state = { createPurchaseOrder: {} }, action) {
    switch (action.type) {
        case CREATE_PURCHASEORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_PURCHASEORDER_SUCCESS:
            return {
                ...state,
                createPurchaseOrder: action.payload,
                isLoading: false
            }
        case CREATE_PURCHASEORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getPurchaseOrderReducer(state = { purchaseOrder: [], purchaseOrderPagination: {} }, action) {
    switch (action.type) {
        case GET_PURCHASEORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PURCHASEORDER_SUCCESS:
            return {
                ...state,
                purchaseOrder: action.payload,
                isLoading: false
            }
        case GET_PURCHASEORDER_PAGINATION:
            return {
                ...state,
                purchaseOrderPagination: action.payload,
                isLoading: false
            }
        case GET_PURCHASEORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getVendorPurchaseOrderReducer(state = { vendorPurchaseOrder: [] }, action) {
    switch (action.type) {
        case GET_VENDORPURCHASEORDER_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_VENDORPURCHASEORDER_SUCCESS:
            return {
                ...state,
                vendorPurchaseOrder: action.payload,
                isLoading: false
            }
        case GET_VENDORPURCHASEORDER_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getSelectedPOReducer(state = { allCheckData: [], allSoIds: [] }, action) {
    switch (action.type) {
        case GET_SELECTEDPO_SUCCESS:
            const data = state.allCheckData.filter(({ soId }) =>
                soId == action.payload.soId
            )
            if (data.length > 0) {
                const data = state.allCheckData.filter(({ soId }) => soId != action.payload.soId)
                const idsData = state.allSoIds.filter((soId) => soId != action.payload.soId)
                return {
                    allCheckData: data,
                    allSoIds: idsData
                }
            } else {
                return {
                    ...state,

                    allCheckData: [...state.allCheckData, action.payload],
                    allSoIds: [...state.allSoIds, action.payload.soId]
                }
            }
        case CLEAR_SELECTED_PO:
            return {
                ...state,
                allCheckData: [],
                allSoIds: []
            }
        default:
            return state;
    }
}

export { getPurchaseOrderReducer, createPurchaseOrderReducer, updatePurchaseOrderReducer, deletePurchaseOrderReducer, getVendorPurchaseOrderReducer, generatePdfReducer , getSelectedPOReducer}